import type {
  PatientInfoApi,
  SessionDownloadLinkApi,
  NotesApi,
  NotesUpdateQuery,
  UpdatePatientInfoQueryApi,
  SessionApiUpdateQuery,
  SessionApiRegisterQuery,
  SessionsSummaryApi,
  SessionApi,
} from "@/Modules/Models/Api/ClinicalHistory";

import { get2, patch2, post2 } from "./utils/FunctionalTherapyApi";

export async function getPatient(customerId: string): Promise<PatientInfoApi> {
  return get2<void, PatientInfoApi>(`/v1.0/users/${customerId}/clinical_history/patient`);
}

export async function updatePatientInfo(
  customerId: string,
  patientInfoId: string,
  info: Partial<UpdatePatientInfoQueryApi>
): Promise<PatientInfoApi> {
  return patch2<Partial<UpdatePatientInfoQueryApi>, PatientInfoApi>(
    `/v1.0/users/${customerId}/clinical_history/patient/${patientInfoId}`,
    info
  );
}

export async function getSessions(customerId: string): Promise<SessionsSummaryApi> {
  return get2<void, SessionsSummaryApi>(
    `/v2.0/users/${customerId}/clinical_history/sessions`,
    undefined,
    undefined,
    { raw: true }
  );
}

export async function getSessionById(customerId: string, sessionId: string): Promise<SessionApi> {
  return get2<void, SessionApi>(`/v1.0/users/${customerId}/clinical_history/sessions/${sessionId}`);
}

export function getSessionDownloadLink(
  customerId: string,
  sessionUuid: string
): Promise<SessionDownloadLinkApi> {
  return get2<string, SessionDownloadLinkApi>(
    `/v1.0/users/${customerId}/clinical_documentation/${sessionUuid}/pdf`
  );
}

export async function registerSession(
  customerId: string,
  info: SessionApiRegisterQuery
): Promise<SessionApi> {
  return post2<SessionApiRegisterQuery, SessionApi>(
    `/v1.0/users/${customerId}/clinical_history/sessions`,
    info
  );
}

export async function updateSession(
  customerId: string,
  sessionId: string,
  info: SessionApiUpdateQuery
): Promise<SessionApi> {
  return patch2<SessionApiUpdateQuery, SessionApi>(
    `/v1.0/users/${customerId}/clinical_history/sessions/${sessionId}`,
    info
  );
}

export async function getNotes(customerId: string): Promise<NotesApi> {
  return get2<void, NotesApi>(`/v1.0/users/${customerId}/clinical_history/notes`);
}

export async function updateNotes(customerId: string, noteId: string, notes: string): Promise<NotesApi> {
  return patch2<NotesUpdateQuery, NotesApi>(`/v1.0/users/${customerId}/clinical_history/notes/${noteId}`, {
    notes,
  });
}
